import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import useSpeechToText from "./useSpeechToText";
import stringSimilarity from "string-similarity";
import ReadingQues from "./ReadingQues";
import DesignedButton from "../design/DesignedButton";
import VoiceRecognitionBar from "../design/VoiceRecognitionBar";
import { useRecoilState } from "recoil";
import { readingProblemTypeAtom } from "../atoms/readingProblemTypeAtom";

const dummy: Story = {
  title: "토끼와 곰의 숲속 모험",
  contents: [
    {
      idx: 1,
      title: "숲속의 친구들",
      content:
        "어느 날, 작은 토끼와 큰 곰이 숲속에서 만났어요. 토끼는 항상 빠르고 밝았지만, 곰은 조금 우울해 보였어요. 둘은 서로 인사하고, 함께 놀기로 했어요.",
    },
    {
      idx: 2,
      title: "모험을 떠나다",
      content:
        "토끼는 곰에게 재밌는 곳이 있다고 말했어요. 그래서 두 친구는 숲속 깊은 곳으로 모험을 떠났어요. 그곳에는 예쁜 꽃과 반짝이는 나무들이 있었어요.",
    },
    {
      idx: 3,
      title: "위험한 순간",
      content:
        "하지만 갑자기 비가 내리기 시작했어요. 토끼는 미끄러운 길에서 넘어지고 말았어요.",
    },
    {
      idx: 4,
      title: "우정을 확인하다",
      content:
        "토끼는 곰의 도움 덕분에 안전하게 일어날 수 있었어요. '고마워, 곰이 없었다면 난 큰일 날 뻔했어.' 토끼가 말했어요. 곰은 흐뭇하게 웃었어요.",
    },
    {
      idx: 5,
      title: "서로의 힘이 되다",
      content:
        "비가 그치고 두 친구는 다시 길을 나섰어요. 이번에는 곰이 토끼를 도와주기로 했어요. 곰은 큰 몸으로 토끼를 안전하게 보호해 주었어요.",
    },
    {
      idx: 6,
      title: "함께한 즐거운 시간",
      content:
        "두 친구는 다시 식사를 하면서 재미있는 이야기를 나누었어요. 서로의 재밌는 이야기를 듣고 웃으며 시간을 보냈어요. 우정이 더욱 깊어졌어요.",
    },
    {
      idx: 7,
      title: "귀가하는 길",
      content:
        '모험이 끝나고 집으로 돌아가는 길, 둘은 서로에게 약속했어요. "다음에 또 함께 모험하자!" 곰과 토끼는 행복한 마음으로 돌아갔어요.',
    },
    {
      idx: 8,
      title: "교훈",
      content:
        "오늘의 모험은 두 친구가 서로 도와주고 우정을 더욱 단단하게 만든 날이었어요. 어려운 순간에도 서로를 믿고 의지한다면, 어떤 어려움도 이겨낼 수 있답니다.",
    },
  ],
};

export const base64ToBlob = (base64: string, mimeType: string): Blob => {
  const byteCharacters = atob(base64); // Base64 디코딩
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: mimeType });
};

interface Content {
  idx: number;
  title: string;
  content: string;
}
interface Story {
  title: string;
  contents: Content[];
}
export interface Sentence {
  contents: string[];
  ssml: string;
}

const ReadingMain = () => {
  const [step, setStep] = useState<number>(0); // 0:시작 전 1:문제 생성중 2:생성완료 3:문장 듣고 말하기
  const [story, setStory] = useState<Story>();
  const [numberOfContents, setNumberOfContents] = useState(0);
  const [curContent, setCurContent] = useState<number>(0);
  const [sentences, setSentences] = useState<Sentence[]>([]);
  const [curSentence, setCurSentence] = useState<number>(0);
  const [numberOfIncorrectShadowing, setNumberOfIncorrectShadowing] =
    useState(0);

  const [problemType, setProblemType] = useRecoilState(readingProblemTypeAtom);

  const audioElement = useRef<HTMLAudioElement | null>(null);

  const [mainText, setMainText] = useState<string>("");
  const [tmpText, setTmpText] = useState<string>("");

  const { transcript, listening, toggleListening, resetTranscript } =
    useSpeechToText();

  const [showQues, setShowQues] = useState<boolean>(false);

  const [isVoiceRecognitionRight, setIsVoiceRecognitionRight] = useState(0);
  const [numberOfChapter, setNumberOfChapter] = useState(0);

  const startStudy = async () => {
    setStep(1); // 문제 생성 중 15초 정도 소요
    /*const res = await axios.get(
      "https://uvlqtxcfrh.us14.qoddiapp.com/reading/story"
    );*/
    setStep(2);
    // setStory(res.data);
    setStory(dummy);
    setNumberOfContents(dummy.contents.length);
  };

  useEffect(() => {
    if (story) {
      //스토리가 생성되면
      setStep(3);
      if (problemType !== 3) {
        splitContent();
      }
    }
  }, [story, curContent]);
  //다음컨텐츠로 넘어가도록

  const splitContent = async () => {
    const targetContent = story?.contents[curContent];
    const res = await axios.post(
      "https://uvlqtxcfrh.us14.qoddiapp.com/reading/split",
      { input: targetContent!.content }
    );
    const obj: Sentence[] = res.data.output.map((row: any, idx: number) => {
      return { contents: row.contents, ssml: res.data.ssmls[idx] };
    });
    setMainText(
      (prev) =>
        prev +
        `${prev === "" ? "" : "\n"}${targetContent?.idx} : ${
          targetContent?.title
        }\n`
    );
    setCurSentence(0);
    setSentences(obj);
  };

  useEffect(() => {
    if (sentences.length > 0) speakSentence();
  }, [sentences, curSentence]);

  const speakSentence = async () => {
    const targetSentence = sentences[curSentence];
    const res = await axios.post(
      "https://uvlqtxcfrh.us14.qoddiapp.com/reading/tts/sentence",
      { ssml: targetSentence.ssml }
    );
    const { audioContent, timepoints } = res.data;
    const audioBlob = base64ToBlob(audioContent, "audio/mp3");
    const audioUrl = URL.createObjectURL(audioBlob);
    const orgMainText = mainText;

    // 오디오 요소 생성 및 바로 실행
    audioElement.current = new Audio(audioUrl);
    audioElement.current.play(); // 바로 오디오 실행

    // 타임포인트 추적 및 출력
    const checkTimepoints = () => {
      const currentTime = audioElement.current?.currentTime;

      // 각 타임포인트 시간에 해당하는 markName을 출력
      timepoints.forEach(
        (timepoint: { markName: string; timeSeconds: number }, idx: number) => {
          if (
            currentTime &&
            currentTime >= timepoint.timeSeconds &&
            currentTime < timepoint.timeSeconds + 0.1 &&
            idx < timepoints.length
          ) {
            if (timepoint.markName === "sentence") {
              setMainText(orgMainText);
              setTmpText(targetSentence.contents.join(" "));
            } else {
              const contenteIdx = Number(
                timepoint.markName.replace("pos-", "")
              );
              const targetText = targetSentence.contents[contenteIdx];
              const tmpMainText =
                orgMainText +
                " " +
                targetSentence.contents.slice(0, contenteIdx).join(" ");
              setMainText(tmpMainText);
              setTmpText(targetText);
            }
          }
        }
      );
    };
    // 100ms마다 타임포인트를 체크
    const intervalId = setInterval(checkTimepoints, 100);

    // 음성 끝날 때 interval을 클리어
    audioElement.current.onended = () => {
      clearInterval(intervalId);
      setMainText(orgMainText + " " + targetSentence.contents.join(" "));
      setTmpText("");
    };
    audioElement.current.onpause = () => {};
  };

  const onSubmitTranscript = () => {
    const targetSentence = sentences[curSentence];
    const sentence = targetSentence.contents.join(" ");
    const similarity = stringSimilarity.compareTwoStrings(sentence, transcript);

    if (listening) {
      toggleListening(); // 음성 인식을 멈춤
      setTimeout(() => resetTranscript(), 200); // 약간의 지연 후 초기화
    } else {
      resetTranscript();
    }
    setIsVoiceRecognitionRight(0);
    if (similarity >= 0.7) {
      //음성인식 성공
      setIsVoiceRecognitionRight(1);
      setNumberOfIncorrectShadowing(0);

      if (curSentence < sentences.length - 1) {
        setCurSentence((prev) => prev + 1);
      } else {
        setShowQues(true);
      }
    } else {
      //TODO 음성 인식 실패했을때
      setNumberOfIncorrectShadowing((prev) => prev + 1);
      if (numberOfIncorrectShadowing === 2) {
        if (curSentence < sentences.length - 1) {
          setCurSentence((prev) => prev + 1);
          setNumberOfIncorrectShadowing(0);
        } else {
          setShowQues(true);
          setNumberOfIncorrectShadowing(0);
        } // 이 부분 테스트 해보기
      }
      setIsVoiceRecognitionRight(-1);
    }
  };

  return (
    <section className="bg-gray-200 dark:bg-gray-700">
      <div className="max-w-screen-xl px-4 py-10 mx-auto lg:px-6">
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <div className="flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border border-gray-100 rounded-lg shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
            <div className="text-3xl font-bold mb-5">독해학습📚💬</div>
            {step === 0 && (
              <DesignedButton
                color="blue"
                text="시작하기!"
                onClickFunction={startStudy}
              ></DesignedButton>
            )}

            <div>
              {problemType === 3 ? (
                "학습 끝. 학습을 더하시고 싶으시면 새로고침 하세요."
              ) : (
                <div>
                  <div className="">
                    {" "}
                    <div>{step === 1 && <div>문제 생성중...</div>}</div>
                    {story && (
                      <div className="">
                        <div className="font-bold text-xl text-pretty mb-2">
                          📖{story.title}📖
                        </div>
                        <div className="shadow-xl p-3 rounded-lg mb-10 border border-gray-200 dark:border-slate-500">
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                mainText.replace(/\n/g, "<br />") +
                                ` <p class="text-[#FFCA3A] inline">${tmpText}</p>`,
                            }}
                          ></div>
                        </div>

                        {showQues && (
                          <ReadingQues
                            sentences={sentences}
                            listening={listening}
                            transcript={transcript}
                            toggleListening={toggleListening}
                            resetTranscript={resetTranscript}
                            setCurContent={setCurContent}
                            curContent={curContent}
                            setShowQues={setShowQues}
                            numberOfContents={numberOfContents}
                          />
                        )}
                      </div>
                    )}
                  </div>
                  <div className="text-pink-500">
                    {isVoiceRecognitionRight === 0 || showQues
                      ? ""
                      : isVoiceRecognitionRight === 1
                      ? "잘하셨어요!"
                      : numberOfIncorrectShadowing === 2
                      ? "다음에 틀리면 문제를 넘깁니다."
                      : "틀렸습니다."}
                  </div>
                  {step === 0 || showQues ? (
                    ""
                  ) : (
                    <VoiceRecognitionBar
                      listening={listening}
                      transcript={transcript}
                      toggleListening={toggleListening}
                      onSubmitTranscript={onSubmitTranscript}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReadingMain;
